module.exports = __webpack_public_path__ + "img/other_income.8454cd9e.svg";